








import React, { useEffect, useState } from 'react';
import API from '../utils/axiosInstance';
// import '../AdminPage/components/Pharmacy/';
import Swal from 'sweetalert2';

const Medicines = () => {
  const [medicines, setMedicines] = useState([]);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    description: '',
    unitPrice: '',
    expiryDate: '',
    manufacturer: ''
  });
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    fetchMedicines();
  }, []);

  const fetchMedicines = () => {
    API.get('/v1/medicines')
      .then((response) => setMedicines(response.data))
      .catch((error) => console.error('Error fetching medicines:', error));
  };

  const handleSaveMedicine = () => {
    const payload = {
      name: formData.name.trim(),
      description: formData.description.trim(),
      unitPrice: parseFloat(formData.unitPrice),
      expiryDate: formData.expiryDate,
      manufacturer: formData.manufacturer.trim()
    };

    if (formData.id) {
      API.patch(`/v1/medicines/${formData.id}`, payload)
        .then(() => {
          fetchMedicines();
          resetForm();
        })
        .catch((error) => console.error('Error updating medicine:', error));
    } else {
      API.post('/v1/medicines', payload)
        .then(() => {
          fetchMedicines();
          resetForm();
        })
        .catch((error) => console.error('Error adding medicine:', error));
    }
  };

const handleDeleteMedicine = (medicineId) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to delete this medicine?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      API.delete(`/v1/medicines/${medicineId}`)
        .then(() => {
          fetchMedicines();
          Swal.fire('Deleted!', 'The medicine has been deleted.', 'success');
        })
        .catch((error) => {
          console.error('Error deleting medicine:', error);

          const errorMessage = error?.response?.data || 'Unexpected server error';

          if (
            typeof errorMessage === 'string' &&
            errorMessage.includes('constraint') &&
            error.response?.status === 500
          ) {
            Swal.fire(
              'Delete Failed!',
              'This medicine is linked to other records and cannot be deleted.',
              'error'
            );
          } else {
            Swal.fire(
              'Error!',
              errorMessage,
              'error'
            );
          }
        });
    }
  });
};



  const handleEditClick = (medicine) => {
    setFormData(medicine);
    setShowPopup(true);
  };

  const resetForm = () => {
    setFormData({
      id: '',
      name: '',
      description: '',
      unitPrice: '',
      expiryDate: '',
      manufacturer: ''
    });
    setShowPopup(false);
  };

  return (
    <div className="medicines-container px-3 py-2">
      <h4 style={{ color: 'black' }}>Medicines</h4>
      <button onClick={() => setShowPopup(true)} className="add-btn btn-color">
        <b>Add Medicine</b>
      </button>

      <div className="table-wrapper">
        <table className=" table-bordered table-striped">
          <thead className="table-dark text-white tableborder">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Description</th>
              <th>Unit Price</th>
              <th>Expiry Date</th>
              <th>Manufacturer</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {medicines.map((medicine, index) => (
              <tr key={medicine.id} className='datahover'>
                <td>{index + 1}</td>
                <td>{medicine.name}</td>
                <td>{medicine.description}</td>
                <td>{medicine.unitPrice}</td>
                <td>{medicine.expiryDate}</td>
                <td>{medicine.manufacturer}</td>
                <td>
                  <button className="btn-color px-1 py-1" onClick={() => handleEditClick(medicine)}>✏️</button>
                  <button className="delete-btn px-1 py-1" onClick={() => handleDeleteMedicine(medicine.id)}>🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h4>{formData.id ? 'Edit' : 'Add'} Medicine</h4>
            <input
              type="text"
              placeholder="Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <input
              type="text"
              placeholder="Description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
            <input
              type="number"
              placeholder="Unit Price"
              value={formData.unitPrice}
              onChange={(e) => setFormData({ ...formData, unitPrice: e.target.value })}
            />
            <input
              type="date"
              placeholder="Expiry Date"
              value={formData.expiryDate}
              onChange={(e) => setFormData({ ...formData, expiryDate: e.target.value })}
            />
            <input
              type="text"
              placeholder="Manufacturer"
              value={formData.manufacturer}
              onChange={(e) => setFormData({ ...formData, manufacturer: e.target.value })}
            />
            <button onClick={handleSaveMedicine}>{formData.id ? 'Update' : 'Add'}</button>
            <button onClick={resetForm}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Medicines;
